import { userConstants } from "../constants/login.constants";

 function shareHolderDetails(state = {}, action) {
    switch (action.type) {
        case userConstants.SHAREHOLDERDETAILSREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.SHAREHOLDERDETAILSREPORT_SUCCESS:
            return {
                items: action.shareHolderDetails
            };
        case userConstants.SHAREHOLDERDETAILSREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default shareHolderDetails;